module.exports = __webpack_public_path__ + "img/coverPlaceLight.96aaebf9.png";